import React from 'react'
import EmployerUrgentRequestForm from '../jobbermanFormat/UrgentRequestForEmployer'
import EmployerAcceptedRequests from '../EmployerUrgentAcceptRequest'
const UrgentStaff = () => {
  return (
    <div>
    <EmployerUrgentRequestForm/>
    <EmployerAcceptedRequests />
      
    </div>
  )
}

export default UrgentStaff
